import type { NodeLogin, OauthToken } from 'models';
import { useMutation } from 'query';
import { storeRailsTokensData } from 'common/services';
import { useSetIsAuthenticated } from 'features/auth';

type Variables = {
  nodeLogin: () => Promise<NodeLogin>;
  railsLogin: () => Promise<OauthToken>;
};

export const useAuthenticateMutation = () => {
  const setIsAuthenticated = useSetIsAuthenticated();

  return useMutation<undefined, Variables>({
    async mutationFn({ nodeLogin, railsLogin }: Variables) {
      const tokenData = await railsLogin();
      storeRailsTokensData(tokenData);

      await nodeLogin();
    },
    onSuccess() {
      setIsAuthenticated(true);
    },
  });
};
